import { Component, OnInit } from '@angular/core';

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'dc-pricing-plan',
  templateUrl: './pricing-plan.component.html',
  styleUrls: ['./pricing-plan.component.scss']
})
export class PricingPlanComponent implements OnInit {
  plans = [
    {
      icon: 'box',
      plan: {
        name: 'Personal',
        price: 0.99,
        description:
          'Includes simple but powerful functionality for individuals and small teams. You can upgrade on the way'
      },
      features: [
        {
          name: 'Cras justo odio',
          class: 'strike-through'
        },
        {
          name: 'Dapibus ac facilisis in',
          class: 'strike-through'
        },
        {
          name: 'Morbi leo risus',
          class: 'strike-through'
        },
        {
          name: 'Porta ac consectetur ac'
        },
        {
          name: 'Vestibulum at eros'
        }
      ]
    },
    {
      icon: 'download-cloud',
      best: true,
      plan: {
        name: 'Business',
        price: 29.99,
        description:
          'For settle companies looking to stay competitive in the market and growing with the technology'
      },
      features: [
        {
          name: 'Cras justo odio',
          class: 'strike-through'
        },
        {
          name: 'Dapibus ac facilisis in',
          class: 'strike-through'
        },
        {
          name: 'Morbi leo risus'
        },
        {
          name: 'Porta ac consectetur ac'
        },
        {
          name: 'Vestibulum at eros'
        }
      ]
    },
    {
      icon: 'settings',
      plan: {
        name: 'Enterprise',
        price: 99.99,
        description:
          'Everything you can get from a professional solution to keep your business on its way to success'
      },
      features: [
        {
          name: 'Cras justo odio'
        },
        {
          name: 'Dapibus ac facilisis in'
        },
        {
          name: 'Morbi leo risus'
        },
        {
          name: 'Porta ac consectetur ac'
        },
        {
          name: 'Vestibulum at eros'
        }
      ]
    }
  ];
  currentSlide: number = 0;

  valor: number = 5;
  precio: number = 15;
  max = 200;
  min = 5;
  step = 5;
  diezMes: number = 3;
  veinteMes: number = 2.5;
  treintaMes: number = 2;
  cincuentaMes: number = 1.5;
  cincoAnyo: number = 150;
  diezAnyo: number = 300;
  veinteAnyo: number = 480;
  treintaAnyo: number = 540;
  cincuentaAnyo: number = 600;
  totalcincoAnyo: number = 180;
  totaldiezAnyo: number = 360;
  totalveinteAnyo: number = 600;
  totaltreintaAnyo: number = 720;
  totalcincuentaAnyo: number = 900;

  totalcincoMes: number = 15;
  totaldiezMes: number = 30;
  totalveinteMes: number = 50;
  totaltreintaMes: number = 60;
  totalcincuentaMes: number = 75;

  ahorrototalcincoAnyo: number = 30;
  ahorrototaldiezAnyo: number = 60;
  ahorrototalveinteAnyo: number = 600;
  ahorrototaltreintaAnyo: number = 720;
  ahorrototalcincuentaAnyo: number = 900;
  thumbLabel = true;
  showTicks: boolean = true;
  autoTicks: boolean = true;
  constructor() {}

  ngOnInit() {}

  updateSlider(currentSlide) {
    this.currentSlide = currentSlide;
  }
  updateSetting(event) {
    if (event.value <= 5) {
      if (this.currentSlide == 0) {
        this.precio = 5 * this.diezMes;
        console.log('precio ', this.precio);
      } else {
        this.precio = 5 * this.diezAnyo * 12;
      }
    } else if (event.value > 5 && event.value <= 10) {
      if (this.currentSlide == 0) {
        this.precio = 10 * this.diezMes;
        console.log('precio ', this.precio);
      } else {
        this.precio = 10 * this.diezAnyo * 12;
      }
    } else if (event.value > 10 && event.value <= 20) {
      if (this.currentSlide == 0) {
        this.precio = 20 * this.veinteMes;
        console.log('precio 15 ', this.precio);
      } else {
        this.precio = 20 * this.veinteAnyo * 12;
      }
    } else if (event.value >= 20 && event.value < 30) {
      if (this.currentSlide == 0) {
        this.precio = 30 * this.veinteMes;
      } else {
        this.precio = 30 * this.veinteAnyo * 12;
      }
    } else if (event.value >= 30 && event.value <= 50) {
      if (this.currentSlide == 0) {
        this.precio = 50 * this.treintaMes;
      } else {
        this.precio = 50 * this.treintaAnyo * 12;
      }
    } else if (event.value >= 50) {
      if (this.currentSlide == 0) {
        this.precio = event.value * this.cincuentaMes;
      } else {
        this.precio = event.value * this.cincuentaAnyo * 12;
      }
    }
  }

  formatLabel(value: number) {
    console.log(this.currentSlide);

    return value;
  }
}
